import ModalTypes from './ModalTypes'

export default ModalTypes
